var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconStar = function SvgIconStar(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.333 14.896 10 13.312l2.688 1.584-.709-3 2.313-1.98-3.063-.27L10 6.792 8.77 9.646l-3.062.27 2.334 1.98zm2.667.166-3.417 2.042a.748.748 0 0 1-.833-.042.75.75 0 0 1-.25-.343.7.7 0 0 1-.02-.448l.895-3.813-3.02-2.562a.68.68 0 0 1-.23-.386.9.9 0 0 1 .02-.427.7.7 0 0 1 .23-.343.74.74 0 0 1 .417-.157L7.75 8.23l1.563-3.625A.75.75 0 0 1 10 4.146a.75.75 0 0 1 .688.458L12.25 8.25l3.958.333q.25.021.417.167a.773.773 0 0 1 .24.77.74.74 0 0 1-.24.376l-3 2.562.896 3.813a.7.7 0 0 1-.021.448.75.75 0 0 1-.25.343.75.75 0 0 1-.833.042z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconStar);
export { ForwardRef as ReactComponent };